import { LoadingButton } from '@mui/lab';
import { Checkbox, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { ChangeEvent, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import socket, { IResponse } from '../../socket';
import IChannel from './IChannel';
import axios from 'axios';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export default function NewChannel() {
    const { t } = useTranslation();
    const [type, setType] = useState('caltural');
    const [lang, setLang] = useState('fa');
    const [loading, setLoading] = useState(true);
    const [txtImage, setTxtImage] = useState('');
    const [active, setActive] = useState(false);
    const navigate = useNavigate();
    let { id } = useParams();

    const fileImage = useRef<HTMLInputElement>(null);
    const txtName = useRef<HTMLInputElement>();

    const handleChangeType = (event: any) => {
        setType(event.target.value)
    }

    const handleChangeLang = (event: any) => {
        setLang(event.target.value)
    }

    const handleEdit = () => {
        setLoading(true);
        const data = {
            id,
            name: txtName.current!.value,
            image: txtImage,
            type,
            lang,
            visible: active,
        }
        socket.emit('channel:edit', data, (data: IResponse<null>) => {
            setLoading(false);
            if (data.success) {
                navigate('/channel');
            }
        });
    }

    const toggleActive = () => {
        setActive(!active);
    }

    const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length === 1) {
            const file = files[0];
            setLoading(true);
            const formData = new FormData();
            formData.append('file', files[0]);
            axios({
                url: `${process.env.REACT_APP_BASE_URL ?? 'http://localhost:5000/api/'}/upload`,
                method: 'POST',
                data: formData,
                headers: {
                    Authorization: localStorage.getItem('admin_rezvan_token')
                }
            }).then((res) => {
                setLoading(false);
                if (res.data.status) {
                    setTxtImage(res.data.result);
                } else {
                    // TODO: show error message
                }
            }).catch((err) => {
                setLoading(false);
            });

        }
    };
    
    const handleClickUploadFile = () => {
        fileImage.current!.click();
    }

    useEffect(() => {
        socket.emit('channel:info', id, (data: IResponse<IChannel>) => {
            setLoading(false);
            if (data.success) {
                console.log(data.result);
                
                txtName.current!.value = data.result.name;
                setTxtImage(data.result.image);
                setType(data.result.type);
                setLang(data.result.lang);
                // @ts-ignore
                setActive(data.result.visible);
            }
        })
    }, [])

    return (
        <>
            <Typography className="m-4">{t('new_channel')}</Typography>
            <Grid container className='mx-4' spacing={2}>
                <Grid xs={12} md={6}>
                    <TextField defaultValue={t('channel_name')} inputRef={txtName} fullWidth label={t('channel_name')} />
                </Grid>
                <Grid className="flex flex-row space-x-2 space-x-reverse" xs={12} md={6}>
                    <TextField value={txtImage} className='grow' label={t('image_url')} disabled />
                    <input type='file' className='hidden' ref={fileImage} onChange={handleChangeFile} />
                    <IconButton color='primary' onClick={handleClickUploadFile}>
                        <CloudUploadIcon />
                    </IconButton>
                </Grid>
                <Grid xs={12} md={6}>
                    <FormControl fullWidth>
                        <InputLabel>{t('channel_type')}</InputLabel>
                        <Select
                            value={type}
                            label={t('channel_type')}
                            onChange={handleChangeType}
                        >
                            <MenuItem value='caltural'>{t('caltural')}</MenuItem>
                            <MenuItem value='news'>{t('news')}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid xs={12} md={6}>
                    <FormControl fullWidth>
                        <InputLabel>{t('language')}</InputLabel>
                        <Select
                            value={lang}
                            label={t('language')}
                            onChange={handleChangeLang}
                        >
                            <MenuItem value='fa'>{t('fa')}</MenuItem>
                            <MenuItem value='en'>{t('en')}</MenuItem>
                            <MenuItem value='ar'>{t('ar')}</MenuItem>
                            <MenuItem value='ur'>{t('ur')}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid xs={12} md={6}>
                    <FormControlLabel control={<Checkbox checked={active} onClick={toggleActive} />} label={t('active')} />
                </Grid>
                <Grid xs={12}>
                    <LoadingButton loading={loading} onClick={handleEdit} variant='contained'>{t('edit')}</LoadingButton>
                </Grid>
            </Grid>
        </>
    )
}
